export enum PageHeaderActionVariant {
  FINISH_TASK = 'FINISH_TASK',
}
